export default __webpack_public_path__ + "static/media/gcw-placeholder.381395d4.png";